// extracted by mini-css-extract-plugin
module.exports = {"link":"Navigation_link__2yXZO","activeLink":"Navigation_activeLink__1Bij9 Navigation_link__2yXZO"};